import { Injectable } from "@angular/core";
import { ToastMessage } from "../models/ToastMessage";
import { Subject } from "rxjs";
@Injectable({
  providedIn: 'root'
})
export class ToastService {
    private toastSubject = new Subject<ToastMessage>();
    toast$ = this.toastSubject.asObservable();
  
    show(type: ToastMessage['type'], title: string, message: string) {
      this.toastSubject.next({ type, title, message });
    }
  }